var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:play-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 20.75C9.67936 20.75 7.45376 19.8281 5.81282 18.1872C4.17187 16.5462 3.25 14.3206 3.25 12C3.25 9.67936 4.17187 7.45376 5.81282 5.81282C7.45376 4.17187 9.67936 3.25 12 3.25C14.3206 3.25 16.5462 4.17187 18.1872 5.81282C19.8281 7.45376 20.75 9.67936 20.75 12C20.75 14.3206 19.8281 16.5462 18.1872 18.1872C16.5462 19.8281 14.3206 20.75 12 20.75ZM12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.83875 8.31885C9.94098 8.26621 10.0558 8.24279 10.1704 8.25117C10.2851 8.25955 10.3953 8.29941 10.4888 8.36635L14.8638 11.4914C14.9448 11.5492 15.0108 11.6255 15.0564 11.714C15.1019 11.8025 15.1257 11.9006 15.1257 12.0001C15.1257 12.0996 15.1019 12.1977 15.0564 12.2862C15.0108 12.3747 14.9448 12.451 14.8638 12.5089L10.4888 15.6339C10.3953 15.7007 10.2852 15.7406 10.1706 15.7489C10.056 15.7573 9.94124 15.7339 9.83905 15.6814C9.73685 15.6288 9.65114 15.549 9.59132 15.4509C9.53151 15.3528 9.49991 15.24 9.5 15.1251V8.8751C9.49988 8.76021 9.53143 8.6475 9.5912 8.54937C9.65096 8.45124 9.73661 8.37148 9.83875 8.31885V8.31885Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiPlayCircle);
export default __webpack_public_path__ + "static/media/bi_play-circle.08ea1785fcde2d0c1248e453495aa36e.svg";
export { ForwardRef as ReactComponent };